import { useEffect, useState } from 'react';

/**
 * Becomes true only after `active` has stayed true for `delayMs`; resets immediately when
 * `active` turns false. Used so brief blips don't flash a "Reconnecting…" screen.
 */
export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [flag, setFlag] = useState(false);
  useEffect(() => {
    if (!active) {
      setFlag(false);
      return;
    }
    const t = window.setTimeout(() => setFlag(true), delayMs);
    return () => window.clearTimeout(t);
  }, [active, delayMs]);
  return active && flag;
}
